var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es488.js.map
